import { useLocaleContext } from 'providers/LocaleProvider';
import React from 'react';
import { Helmet } from 'react-helmet';
import { useRouter } from 'next/router';
import { getCanonicalAttr } from 'utils/helmet';

/*
Each page has its own helmet
If there is any page having no helmet, it will get HomeHelmet de
*/
const HomeHelmet = () => {
  const { language, locale: t } = useLocaleContext();
  const { asPath } = useRouter();

  return (
    <Helmet>
      <title>{t('hc.page.default.title')}</title>
      <meta name="description" content={t('hc.meta.default.description')} />
      <link {...getCanonicalAttr(language, asPath)} />
    </Helmet>
  );
};

export default HomeHelmet;
